import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

const TrustBadges = () => {
  const { i18n } = useTranslation();

  const badges = [
    {
      icon: '🔒',
      title: i18n.language === 'en' ? 'Secure' : 'ปลอดภัย',
      subtitle: i18n.language === 'en' ? 'SSL Encrypted' : 'เข้ารหัส SSL'
    },
    {
      icon: '✓',
      title: i18n.language === 'en' ? 'Verified' : 'ตรวจสอบแล้ว',
      subtitle: i18n.language === 'en' ? 'Registered NGO' : 'มูลนิธิจดทะเบียน'
    },
    {
      icon: '📊',
      title: i18n.language === 'en' ? 'Transparent' : 'โปร่งใส',
      subtitle: i18n.language === 'en' ? 'Public Reports' : 'รายงานสาธารณะ'
    },
    {
      icon: '⭐',
      title: i18n.language === 'en' ? '4.9/5 Rating' : 'คะแนน 4.9/5',
      subtitle: i18n.language === 'en' ? '248+ Reviews' : 'รีวิว 248+'
    }
  ];

  return (
    <div style={{
      display: 'flex',
      gap: '1rem',
      justifyContent: 'center',
      flexWrap: 'wrap',
      padding: '2rem 1rem',
      background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
      borderRadius: '16px',
      margin: '2rem 0'
    }}>
      {badges.map((badge, index) => (
        <motion.div
          key={index}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            padding: '1rem 1.5rem',
            background: 'white',
            borderRadius: '12px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
            minWidth: '200px'
          }}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: index * 0.1 }}
          whileHover={{
            scale: 1.05,
            boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
            y: -5
          }}
        >
          <div style={{ fontSize: '2rem' }}>{badge.icon}</div>
          <div>
            <div style={{
              fontWeight: '700',
              fontSize: '0.95rem',
              color: '#1e3c72',
              marginBottom: '0.25rem'
            }}>
              {badge.title}
            </div>
            <div style={{
              fontSize: '0.8rem',
              color: '#64748b'
            }}>
              {badge.subtitle}
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default TrustBadges;
